<template>
    <div class="number-external-link">
        <div class="head">
            <span style="display:inline-block;width:72px;height:26px;text-align:center;line-height:26px;background:rgba(24, 144, 255, 0.1);color:rgba(24, 144, 255, 1);font-size:13px;">客户账号</span>
            <span style="margin-left:12px;color:rgba(158, 172, 196, 1);font-size:14px;">ID：{{id}}</span>
        </div>
        <div class="body-content">
            <div style="height:100%;width:100%;background:#fff;padding:20px;">
                <a-table :data-source="numberData" :pagination='false'  :rowKey="(record,index)=>{return record.id}">
                    <a-table-column key="number" title="号码" data-index="number">
                        <template slot-scope="text, record">
                            <span style="margin-right:8px">{{record.number}}</span>
                        </template>
                    </a-table-column>
                    <a-table-column key="commodityName" title="商品名称" data-index="commodityName">
                        <template slot-scope="text, record">
                            <span style="margin-right:8px">{{record.commodityName}}</span>
                        </template>
                    </a-table-column>
                    <a-table-column key="useCount" title="呼叫次数" data-index="useCount">
                        <template slot-scope="text, record">
                            <span style="margin-right:8px">{{record.useCount}}</span>
                        </template>
                    </a-table-column>
                    <a-table-column key="allocateTime" title="分配时间" data-index="allocateTime">
                        <template slot-scope="text, record">
                            <span style="margin-right:8px">{{record.allocateTime}}</span>
                        </template>
                    </a-table-column>
                </a-table>
                <div style="margin-top:12px">
                    <a-select @change="changeDays" v-model="callTimes" style="width: 100%;width:150px;">
                        <a-select-option :value="1" key='1'>
                            1天内
                        </a-select-option>
                        <a-select-option :value="7" key='7'>
                            7天内
                        </a-select-option>
                        <a-select-option :value="30" key='30'>
                            30天内
                        </a-select-option>
                        <a-select-option :value="60" key='60'>
                            60天内
                        </a-select-option>
                        <a-select-option :value="90" key='90'>
                            90天内
                        </a-select-option>
                        <a-select-option :value="180" key='180'>
                            180天内
                        </a-select-option>
                        <a-select-option :value="360" key='360'>
                            360天内
                        </a-select-option>
                    </a-select>
                    <span style="color:rgba(80, 80, 80, 1);font-size:14px;">共计：{{numberData.length}}条</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Chat',
        data() {
            return {
                numberData: [],
                id: '',
                callTimes: 30,
            }   
        },
        methods: {
            queryNumberList() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/number/manage/userNumberListExternal', 
                        params: {
                            userId: this.id,
                            days: this.callTimes
                        },
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.numberData = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            changeDays() {
                this.queryNumberList()
            },
        },
        mounted: function() {
            this.id = this.$route.query.id
            this.queryNumberList()
        }
    }
</script>

<style scoped lang="less">
    .number-external-link{
        height: 100%;
        width: 100%;
        background: rgba(240, 242, 243, 1);
        display: flex;
        flex-direction: column;
    }
    .head{
        height: 50px;
        background: #fff;
        padding: 12px 16px;
    }
    .body-content{
        flex: 1;
        padding: 20px 24px 24px;
    }
</style>